export const authHeader = async () => {
  let accessToken = localStorage.getItem("accessToken");
  if (accessToken) {
    return { Authorization: "Bearer " + accessToken };
  } else {
    return {};
  }
};
